exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-35d71246],th[data-v-35d71246]{padding:1px 5px;border:1px solid #dbdbdb}th[data-v-35d71246]{background-color:#f5f5f5}.oscuro[data-v-35d71246]{background-color:grey;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35d71246","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reports/iva/Iva.vue
// module id = 798
// module chunks = 0